import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import AboutHero from '../components/about/AboutHero';
import AboutPlatformSection from '../components/about/AboutPlatformSection';
import CustomerJourneySection from '../components/about/CustomerJourneySection';
import AboutGrowthSection from '../components/about/AboutGrowthSection';
import QuickScanSection from '../components/about/QuickScanSection';
import AnalyticsSection from '../components/about/AnalyticsSection';
import WhySignetPrint from '../components/about/WhySignetPrint';
import MarketplaceSection from '../components/about/MarketplaceSection';
import PricingSection from '../components/about/PricingSection';
import PrintCTASection from '../components/about/PrintCTASection';


const About = () => {

    return (
        <div className="bg-background min-h-full flex flex-col font-['Plus_Jakarta_Sans',sans-serif]">
            <NavBar />

            <AboutHero />

            <AboutPlatformSection />

            <CustomerJourneySection />

            <AboutGrowthSection />

            <QuickScanSection />

            <AnalyticsSection />

            <WhySignetPrint />

            <MarketplaceSection />

            <PricingSection />

            <PrintCTASection />

            <Footer />
        </div>

    );
};

export default About;
